export const SET_STEPPER_OBJECT = "SET_STEPPER_OBJECT";

export const setStepperObject = (response) => {
  return {
    type: SET_STEPPER_OBJECT,
    payload: response,
  };
};
